import script from "./MonthSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonthSelector.vue?vue&type=script&setup=true&lang=ts"

import "./MonthSelector.vue?vue&type=style&index=0&id=1943a8fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1943a8fa"]])

export default __exports__